import axios from "../../utils/axios";
import { BASE_API } from "../../config/app";
// 获取分页信息
export function getPage(moduleKey, params, partKey, url) {
  return axios({
    url: BASE_API.rep(url || BASE_API.basis.page.url, moduleKey, partKey),
    method: "get",
    params: params
  });
}

// 获取分页信息
export function getElongPage(data, params) {
  return axios({
    url: "http://hotelapi.whlyw.net/Help/Api/POST-api-Elong-GetHotelList",
    method: "post",
    params: params,
    data: data
  });
}

// 获取分页信息
export function getHotelPage(params,callBack) {
 $.ajax({
    type: 'post',
    dataType: "json",
    contentType:"application/x-www-form-urlencoded",
    url: "http://hotelapi.whlyw.net/Help/Api/POST-api-Elong-GetHotelList",
    data: params,
    cache: true,
    async: true, //异步
    crossDomain: true,
    success: function (msg) {
        callBack(msg);
    }
});
}